/**
 * Compute the radius of a circle-mode hit circle for a given circle size.
 * @param {number} cs Circle size value (0-10).
 * @returns {number}
 */
import { applyCS, isModActive } from '../../mods.js';

export function circleRadius(cs) {
  cs = applyCS(cs);
  let radius = 54.4 - 4.48 * cs;
  if (isModActive('easy')) radius *= 1.2;
  if (isModActive('hardRock')) radius *= 0.8;
  return radius;
}

const FOLLOW_RADIUS_MULTIPLIER = 2.5;

/**
 * Compute the radius of the approach circle for a given circle size.
 * @param {number} cs Circle size value.
 * @returns {number}
 */
export function followRadius(cs) {
  return circleRadius(cs) * FOLLOW_RADIUS_MULTIPLIER;
}
